module.exports = __webpack_public_path__ + "static/media/featured-video-poster.e11e8df5.webp";